import React from 'react';
import Grid from '@mui/material/Grid';
import InvoiceFormOrder from './InvoiceFormOrders';
import InvoiceCollapsibleActionTable from './InvoiceCollapsibleActionTable';
import reduceDigits from '../../../helper/reduceDigits';
import { userContext } from '../../../context/userContext';
import { getRowsTableInvoices } from '../../../services/filteredTablesServices';
import { useQuery } from '@tanstack/react-query';
import Button from '@mui/material/Button';
export default function InvoicesFilteringTable({ userID }) {
  const { instance, accounts, company } = React.useContext(userContext);

  const [filter, setFilter] = React.useState([
    {
      query: 'CUSTNMBR=',
      filter: userID,
    },
  ]);
  // const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(0);
  // const [countRows, setCountRows] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
 
const {
  isLoading,
  isFetching,
  isError,
  refetch,
  data: { rows, count },
  error,
} = useQuery(
  {
    queryKey: [userID, company, filter, page, rowsPerPage],
    queryFn: () => getRowsTableInvoices(instance, accounts, page, rowsPerPage, filter, company),
    placeholderData: { rows: [], count: 0 },
    staleTime: 0,
    keepPreviousData: true,
    select: (data) => {
      const payload = data?.data?.data;
      const newCount = Number(payload?.count);
      return {
        rows: Array.isArray(payload?.rows) ? reduceDigits(payload.rows) : [],
        count: Number.isFinite(newCount) ? newCount : 0,
      };
    },
    onSuccess: () => {
      // Keep the current page when a background refresh succeeds.
    },
  }
);

  if (isError) {
    return (
      <div>
        <h3>Algo ha fallado..</h3>
        <p>{error.message}</p> {/* Mostrar el mensaje de error */}
        <Button variant='contained' onClick={() => refetch()}>Reintentar</Button>
      </div>
    );
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handlerResetFilter = () => {
    setPage(0);
    setFilter([
      {
        query: 'CUSTNMBR=',
        filter: userID,
      },
    ]);
  };
  const handleFilter = (value) => {
    setPage(0);
    value.forEach((item1) => {
      const index = filter.findIndex((item) => item.query === item1.query);

      if (index > -1) {
        if (item1.filter === '') {
          const newFilter = [...filter];
          newFilter.splice(index, 1);
          return setFilter(newFilter);
        }
        if (filter[index].filter === item1.filter) return;

        //If value is different, replace it
        const newFilter = [...filter];
        newFilter[index] = item1;
        return setFilter(newFilter);
      }

      if (item1.filter === '') {
        return;
      }
      setFilter((prev) => [...prev, item1]);
    });
  };

  return (
    <>
      <Grid
        container
        columnGap={5}
        spacing={0.5}
        paddingTop={1}
        paddingBottom={2}
        justifyContent='end'
      ></Grid>
      <Grid
        item
        sx={{ margin: 0, padding: 0 }}
        xs={2}
      >
        <InvoiceFormOrder
          props={{ userID, filter }}
          function={handleFilter}
          handlerResetFilter={handlerResetFilter}
        />
      </Grid>
      <Grid item xs={10}>
        <InvoiceCollapsibleActionTable
          rows={rows}
          loading={isLoading || isFetching}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          countRows={count}
          rowsPerPage={rowsPerPage}
          page={page}
        />
      </Grid>
    </>
  );
}
